import React from 'react'
import type { LinkBlockProps } from 'components/Cms/Block/Blocks/LinkBlock/types'
import { useHistory } from 'react-router-dom'
import { LinkBlockButton } from './styles'

const LinkBlock: React.FC<LinkBlockProps> = ({ data }) => {
  const history = useHistory()
  const { variant, text } = data

  return (
    <LinkBlockButton variant={variant} fullWidth color="primary" onClick={() => history.push(data.route)}>
      {text}
    </LinkBlockButton>
  )
}

export default LinkBlock
